// extracted by mini-css-extract-plugin
export default {"site-layout":"Sidenav_site-layout__vujlk","site-layout-background":"Sidenav_site-layout-background__+Z2kD","menuLabel":"Sidenav_menuLabel__cmkDR"};